import React from 'react';

const ImageUploadForm = ({ images, setImages, onUpload, uploading }) => {
    const handleImageSelect = (type, files) => {
        if (type === 'screenshots') {
            setImages(prev => ({
                ...prev,
                screenshots: Array.from(files).slice(0, 3)
            }));
        } else {
            setImages(prev => ({ ...prev, [type]: files[0] }));
        }
    };

    return (
        <div className="admin-upload-section">
            <h4 className="admin-upload-title">Upload New Images:</h4>
            
            <div className="admin-form-group">
                <label className="admin-form-label">Banner Image (800x400 recommended):</label>
                <input 
                    type="file" 
                    accept="image/*" 
                    onChange={(e) => handleImageSelect('banner', e.target.files)}
                    className="admin-file-input"
                />
            </div>

            <div className="admin-form-group">
                <label className="admin-form-label">Logo Image (200x200 recommended):</label>
                <input 
                    type="file" 
                    accept="image/*" 
                    onChange={(e) => handleImageSelect('logo', e.target.files)}
                    className="admin-file-input"
                />
            </div>

            <div className="admin-form-group">
                <label className="admin-form-label">Screenshots (max 3):</label>
                <input 
                    type="file" 
                    accept="image/*" 
                    multiple 
                    onChange={(e) => handleImageSelect('screenshots', e.target.files)}
                    className="admin-file-input"
                />
            </div>

            <button 
                className="admin-btn-upload"
                onClick={onUpload}
                disabled={uploading || (!images.banner && !images.logo && images.screenshots.length === 0)}
            >
                {uploading ? 'Uploading...' : 'Upload Images'}
            </button>
        </div>
    );
};

export default ImageUploadForm;